<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            GIAO HÀNG
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <ul class="nav nav-tabs m-5" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_OWNER}" id="owner-tab" data-bs-toggle="tab" data-bs-target="#owner" type="button" role="tab" aria-controls="owner" aria-selected="true" @click="changeTab('owner')">Công ty</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{'active': tabCurrent === AppConstant.TAB_PARTNER}" id="partner-tab" data-bs-toggle="tab" data-bs-target="#partner" type="button" role="tab" aria-controls="partner" aria-selected="false" @click="changeTab('partner')">Đối tác</button>
                    </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="owner" role="tabpanel" aria-labelledby="owner-tab">
                        <TabDeliveryOwnerComponent :tabCurrent="tabCurrent"></TabDeliveryOwnerComponent>
                    </div>
                    <div class="tab-pane fade" id="partner" role="tabpanel" aria-labelledby="partner-tab">
                        <TabDeliveryPartnerComponent :tabCurrent="tabCurrent"></TabDeliveryPartnerComponent>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
